import { render } from "./MiddlePaneHeader.vue?vue&type=template&id=4fa2797e&scoped=true&lang=pug"
import script from "./MiddlePaneHeader.js?vue&type=script&lang=js&external"
export * from "./MiddlePaneHeader.js?vue&type=script&lang=js&external"

import "./MiddlePaneHeader.vue?vue&type=style&index=0&id=4fa2797e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa2797e"]])

export default __exports__